import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { AvailableActionsResponse } from 'types/ActivationOrderTypes';

export type getActivationOrderActionsDataType = {
  id: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'activationOrderActionsData',
}: getActivationOrderActionsDataType) =>
  requestAsync({
    url: endpoints.getAOActionsUrl(id),
    transform: (response: AvailableActionsResponse) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getAOActionsUrl(id)}`,
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      successCallback,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
